







































































import { Vue, Prop, Component } from "vue-property-decorator";
import { Test as ITest } from "@/api/models/test";
import { TestQuestionsListParams } from "@/getinfo-api/test-questions";
import CustomTableItem from "@/components/form/CustomTableItem.vue";
import CustomTableCol from "@/components/form/CustomTableCol.vue";
@Component({
  components: { CustomTableCol, CustomTableItem }
})
export default class TestTable extends Vue {
  @Prop() test!: ITest;
  @Prop() index!: number;
  copySpinner: boolean = false;

  get screenWidth() {
    return window.innerWidth;
  }

  async copyQuestions() {
    this.copySpinner = true;
    let params: TestQuestionsListParams = {
      id: this.test.id,
      limit: 500
    };
    try {
      await this.$store.dispatch(
        "tests/TestsQuestions/GET_QUESTIONS_BY_TEST",
        params
      );
    } finally {
      this.copySpinner = false;
    }
  }
}
